import type { AjaxRequestProvider, AjaxRequestProviderRequestArgs, AjaxRequestProviderRequestResponse } from './api-http';
import { globalState } from '../app/global-state';

export class AjaxProviderXhr implements AjaxRequestProvider {
	sendRequest<T> (args: AjaxRequestProviderRequestArgs): Promise<AjaxRequestProviderRequestResponse> {
		return new Promise((resolve) => {
			const x = new XMLHttpRequest();

			x.open(
				args.method,
				args.url,
				true,
			);

			x.withCredentials = args.withCredentials === true;

			x.onreadystatechange = function () {
				if (x.readyState == 4) {
					let status = x.status;
					if (status == 0) {
						status = -4;
					}

					resolve({
						httpCode: status,
						responseText: x.responseText,
					});
				}
			}
			;(args.headers || []).forEach((ajaxHeader) => {
				x.setRequestHeader(ajaxHeader.name, typeof ajaxHeader.value === 'string' || ajaxHeader.value instanceof String
					? (ajaxHeader.value as string)
					: ajaxHeader.value());
			});

			if (args.timeout != null) {
				x.timeout = args.timeout;
			}

			x.send(args.data);
		});
	}
}

export class AjaxProviderCordova implements AjaxRequestProvider {
	sendRequest<T>(args: AjaxRequestProviderRequestArgs): Promise<AjaxRequestProviderRequestResponse> {
		return new Promise((resolve) => {
			const cordova = globalState.cordova;
			let timeout: number = 45;

			if (args.timeout > 0) {
				timeout = args.timeout / 1000;
			}

			const headerMap = {} as any
          ;(args.headers || []).forEach((header) => {
				headerMap[header.name] = header.value;
			});

			const requestArgs = {
				timeout,
				method: args.method.toLowerCase(),
				serializer: 'json',
				responseType: 'text',
				headers: headerMap,
			};

			if (args.data != null) {
				let data = args.data;
				if (typeof data === 'string' || data instanceof String) {
					data = JSON.parse(data as any);
				}

				;(requestArgs as any).data = data;
			}

			const timeoutEnsure = timeout * 1000 + 3500;
			let cbRaised = false;
			const timeoutEnsureHandle = setTimeout(() => {
				if (!cbRaised) {
					cbRaised = true;
					resolve({
						httpCode: 0,
						responseText: 'timeout',
					});
				}
			}, timeoutEnsure);

			const tryClearTimeoutEnsure = function () {
				cbRaised = true;

				try {
					clearTimeout(timeoutEnsureHandle);
				} catch (e) {}
			};

			cordova.plugin.http.sendRequest(
				args.url,
				requestArgs,
				(response) => {
					if (cbRaised) {
						return;
					}

					tryClearTimeoutEnsure();
					resolve({
						httpCode: response.status,
						responseText: response.data,
					});
				},
				(response) => {
					if (cbRaised) {
						return;
					}

					tryClearTimeoutEnsure();
					resolve({
						httpCode: response.status,
						responseText: response.error,
					});
				},
			);
		});
	}
}
